import {
    Doughnut
} from 'vue-chartjs'
import Chart from 'chart.js'

export default {
    extends: Doughnut,
    props: {
        uptime: {
            type: Number
        },
        downtime: {
            type: Number
        }
    },
    mounted() {
        let centerTextPlugin = {
            id: 'centerText',
            getFontSize: function (chart, options) {
                let helpers = Chart.helpers
                let ctx = chart.chart.ctx

                ctx.save()

                let fontSize = 1
                let maxFontSize = 256
                let maxText = helpers.getValueOrDefault(options.maxText, options.text)

                do {
                    ctx.font = helpers.fontString(fontSize, options.fontStyle, options.fontFamily)
                    let textWidth = ctx.measureText(maxText).width

                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize) {
                        fontSize += 1
                    } else {
                        fontSize -= 1
                        break
                    }
                } while (true)

                fontSize -= 1
                ctx.restore()

                return fontSize
            },
            afterDraw: function (chartInstance) {
                if (chartInstance.options.center) {
                    let centerOptions = chartInstance.options.center
                    let helpers = Chart.helpers
                    let ctx = chartInstance.chart.ctx
                    let fontSize = this.getFontSize(chartInstance, centerOptions)

                    ctx.save()
                    ctx.font = helpers.fontString(fontSize, centerOptions.fontStyle, centerOptions.fontFamily)
                    ctx.fillStyle = '#000'
                    ctx.textAlign = 'center'
                    ctx.textBaseline = 'middle'
                    let centerX = (chartInstance.chartArea.left + chartInstance.chartArea.right) / 2
                    let centerY = chartInstance.chartArea.bottom * 0.8
                    ctx.fillText(centerOptions.text, centerX, centerY)
                    ctx.restore()
                }
            }
        }
        this.addPlugin(centerTextPlugin)

        this.renderChart({
            datasets: [{
                data: [
                    this.uptime,
                    this.downtime
                ],
                backgroundColor: [
                    '#74C080',
                    '#D64242'
                ],
                borderWidth: 0,
                hoverBackgroundColor: [
                    '#74C080',
                    '#D64242'
                ],
                hoverBorderWidth: 0
            }]
        }, {
            cutoutPercentage: 60,
            rotation: -3.1415926535898,
            circumference: 3.1415926535898,
            responsive: true,
            maintainAspectRatio: true,
            legend: {
                display: false
            },
            tooltips: {
                enabled: false
            },
            center: {
                maxText: '100.0000%',
                text: this.uptime.toFixed(3) + '%',
                fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontStyle: 'normal'
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/UptimeChart.js